const VIDEO_NAME_RE = /\.(mp4|mov|avi|webm)$/i;

/** Nhận diện video từ URL (khi thiếu mediaType từ API). */
export function urlLooksLikeResultVideo(url: string | undefined): boolean {
  if (!url) return false;
  const path = url.split('?')[0] || '';
  return VIDEO_NAME_RE.test(path);
}

export function isResultGalleryVideo(photo: {
  name?: string;
  mediaType?: string;
  url?: string;
}): boolean {
  return (
    photo.mediaType === 'video' ||
    VIDEO_NAME_RE.test(photo.name || '') ||
    urlLooksLikeResultVideo(photo.url)
  );
}

/** Ảnh bìa nhóm: ưu tiên 1.jpg (bản layout / sau gallery-edit), tránh video. */
export function getResultGroupCoverUrl<T extends { url: string; name?: string; mediaType?: string }>(
  photos: T[] | undefined
): string | undefined {
  if (!photos?.length) return undefined;
  const byName = (name: string) =>
    photos.find((p) => (p.name || '').toLowerCase() === name && !isResultGalleryVideo(p));

  const preferred =
    byName('1.jpg') ||
    byName('1.jpeg') ||
    byName('1.png') ||
    byName('1.webp') ||
    byName('1_cut2.jpg') ||
    byName('1_cut3.jpg');

  if (preferred?.url) return preferred.url;

  const firstImage = photos.find((p) => !isResultGalleryVideo(p));
  return (firstImage ?? photos[0]).url;
}
